import { NgModule  } from '@angular/core';

import { CustomerActionsComponent }        from './customer.actions.component';
import { CustomerPaymentsModule }          from './customer-payments/customer-payments.module';
import { CustomerVehicleActionsComponent } from './customer.vehicle.actions.component';
import { SharedModule }                    from '../../app-lite/shared/shared.module';

@NgModule({
    declarations: [
        CustomerActionsComponent,
        CustomerVehicleActionsComponent
    ],
    entryComponents: [
        CustomerActionsComponent,
        CustomerVehicleActionsComponent
    ],
    imports: [
        CustomerPaymentsModule,
        SharedModule
    ]
})
export class CustomersModule {}